import { useContext, useState } from 'react';
import { Container, Button, Grid, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';
import { useLocation } from 'react-router';
import { Page } from 'components';


let ChangePassword = () => {
    let location = useLocation<any>();

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);

    let changePasswordSchema = yup.object().shape({
        clientId: yup.string().required('ClientId not set').default(''),
        clientSecret: yup.string().required('Client secret not set').default(''),
        newPassword: yup.string().required('Please set new password').default(''),
        newPasswordConfirm: yup.string()
            .oneOf([yup.ref('newPassword'), null], 'Passwords do not match')
            .required('You have to confirm new password')
            .default('')
    })


    return (
        <Container maxWidth="sm">
            <Page
                useHeader={true}
                isLoading={false}
                title="You must change password before login"
                subtitle="You have used temporary password that need to be changed"
            >
                <Formik
                    initialValues={{
                        ...changePasswordSchema.getDefault(),
                        clientId: location.state?.clientId || '',
                        clientSecret: location.state?.clientSecret || ''
                    }}
                    validationSchema={changePasswordSchema}
                    onSubmit={async (values, action) => {
                        setLoading(true);
                        let res = await authService.signInAndChangePassword(values.clientId, values.clientSecret, values.newPassword);
                        if (res === false) {
                            action.setSubmitting(false);
                            setLoading(false);
                        }
                    }}
                >
                    <Form>
                        <Grid container>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="newPassword"
                                    label="New Password"
                                    variant="outlined"
                                    type="password"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="newPasswordConfirm"
                                    label="Confirm new Password"
                                    variant="outlined"
                                    type="password"
                                />
                            </Grid>
                            <Grid item xs>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    disabled={isLoading}
                                    startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                >
                                    Change password
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default ChangePassword;